import { Primitive } from '../../../../types/blocks/Primitive';

/**
 * @deprecated use PropertyInputBlock instead
 */
const TimeInputBlock: Primitive = {
  name: 'TimeInputBlock',
  friendlyName: 'Time',
  isInput: true,
  isPrimitive: true,
  properties: {
    value: {
      type: 'Time',
      validators: [
        {
          name: 'Required',
          value: true,
        },
      ],
    },
    isValid: {
      type: 'Boolean',
      default: true,
    },
    disabled: {
      type: 'Boolean',
      default: false,
    },
  },
  publishes: {
    // @ts-expect-error ts-migrate(2741) FIXME: Property 'action' is missing in type '{ type: "Eve... Remove this comment to see the full error message
    click: {
      type: 'Event',
    },
    // @ts-expect-error ts-migrate(2741) FIXME: Property 'action' is missing in type '{ type: "Eve... Remove this comment to see the full error message
    submit: {
      type: 'Event',
    },
  },
};

export default TimeInputBlock;
